export const auth0Config = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN
};

export const mapConfig = process.env.REACT_APP_AUTH0_DOMAIN;
export const importOfObjectsConfig = {
  zendeskUrl: process.env.IMPORT_OF_OBJECTS_ZENDESK_URL || "https://support.gsgroup.no/hc/en-us/articles/10802643204753",
  templateFile: "/static/files/ImportOfAssetsTemplate.xlsm"
}

export const quoteEquipmentsZendeskUrl = process.env.QUOTE_EQUIPMENTS_ZENDESK_URL || "https://support.gsgroup.no/hc/en-us/articles/14066131545361-Import-of-objects-for-a-contract-quote"

export const MUI_X_LICENSE = "171ac6b6de47d10ef5635a1f34bc21cbT1JERVI6NDA0NjcsRVhQSVJZPTE2Nzk4Mzg0NzcwMDAsS0VZVkVSU0lPTj0x"